"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllCollectionsEarlyRequestName = exports.maybeEarlyRequest = void 0;

var _q = _interopRequireDefault(require("q"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var maybeEarlyRequest = function maybeEarlyRequest(requestName, requestCb) {
  var earlyRequest = requestName && window.quickFetch && window.quickFetch.getRequestStateByName(requestName);

  if (earlyRequest) {
    var earlyRequestPromise = new _q.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(function () {
        // retry the request
        requestCb().then(resolve).catch(function (err) {
          reject(err);
        });
        window.quickFetch.removeEarlyRequest(requestName);
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute(requestName + "-early-request-used", Boolean(earlyRequest.finished));
    }

    return earlyRequestPromise;
  }

  return requestCb();
};

exports.maybeEarlyRequest = maybeEarlyRequest;

var getAllCollectionsEarlyRequestName = function getAllCollectionsEarlyRequestName(collection) {
  var base = 'all-collections';
  if (!collection) return base; // TODO early requests for other collections

  switch (collection) {
    case StorefrontCollection.POPULAR:
      return base + "-popular";

    case StorefrontCollection.NEW:
      return base + "-new";

    case StorefrontCollection.FREE:
      return base + "-free";

    default:
      return null;
  }
};

exports.getAllCollectionsEarlyRequestName = getAllCollectionsEarlyRequestName;


//////////////////
// WEBPACK FOOTER
// ./js/utils/earlyRequests.js
// module id = 221
// module chunks = 209 210 211 212